<template>
  <div
    class="base-field"
    :class="[{ hasIcon }, { disabled: isDisabled }, baseComputedClass]"
  >
    <label>
      <p>{{ label }}</p>
    </label>
    <div class="base-field__content">
      <slot></slot>
    </div>
    <p v-if="errors" class="error">{{ errors }}</p>
  </div>
</template>

<script setup>
import { computed, inject } from "vue";

const props = defineProps({
  name: {
    type: String,
    default: "baseSelect",
  },
  label: {
    type: String,
    default: null,
  },
  errors: {
    type: String,
    default: null,
  },
  hasIcon: {
    type: Boolean,
    default: false,
  },
  disabled: { type: Boolean, default: false },
});

const baseComputedClass = computed(() =>
  props.hasIcon ? "hasIcon--inset-left" : ""
);

const disableBySelectName = inject("isDisabledByKey");
const isDisabledByInjectionKey = computed(
  () =>
    !!disableBySelectName.value &&
    Object.getOwnPropertyDescriptor(disableBySelectName.value, props.name) &&
    disableBySelectName.value[props.name]
);

const isDisabled = computed(
  () => props.disabled || isDisabledByInjectionKey.value
);
</script>
<style lang="scss">
.base-field {
  display: flex;
  flex-direction: column;
  margin-bottom: $formFieldSpacing;
  position: relative;

  label {
    margin-bottom: 0.5rem;
    margin-left: 0.8rem;
    @include breakpoint($min-m) {
      margin-left: 1.6rem;
    }
  }

  &__content {
    position: relative;
  }

  &.hasIcon {
    svg {
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .caret-down {
      left: calc(100% - 40px);
    }
    &--inset-left {
      input,
      .dropdown-select {
        // add +10px to left to the svg's tag's left px
        padding-left: calc(2rem + 40px);
      }
      svg {
        left: 30px;
      }
    }
  }

  .error {
    position: absolute;
    bottom: 0;
    transform: translateY(110%);
    color: var(--error-color);
  }

  input,
  .dropdown-select {
    padding-inline: 0.75rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: var(--input-background);
    border-radius: 1.5rem;
    border: 1px solid #0072ce00;
    transition: border 250ms;

    &__selected-item {
      padding: 1.75rem 1rem;
      width: 100%;
    }

    &:focus,
    &.isFocused {
      border: $border-focus;
    }

    &.hasErrors {
      outline: 1px solid var(--error-color);
    }

    @include breakpoint($min-m) {
      font-size: $font-body;
    }
  }
}
</style>
